import TextSkeleton from "../TextSkeleton";
import styles from "./style.module.scss";

interface ILongTextBlock {
    /**
     * Text inside the block.
     */
    text: string;
    /**
     * Title of the block (comes from name of field).
     */
    title: string;
    isLoading?: boolean;
}

// Component that renders long text (from textArea field) on Title/Beneficiary page.
const LongTextBlock = ({ text, title, isLoading = false }: ILongTextBlock) => {
    return (
        <div className={styles["longtext-block"]}>
            <h3 className={styles["block-title"]}>{title}</h3>
            <p className={styles["block-text"]} style={{ whiteSpace: "break-spaces" }}>
                {isLoading ? (
                    <>
                        <TextSkeleton width="92%" />
                        <TextSkeleton width="78%" />
                    </>
                ) : (
                    text
                )}
            </p>
        </div>
    );
};

export default LongTextBlock;
